import axios from 'axios';

require('dotenv').config();

export const config = {
  baseUrl: `${process.env.REACT_APP_SERVER_API_HOST}/api-hcm-web-portal/v1`,
};

export const RequestApi = async (url, { data = '', method = 'POST' }) => {
  return axios({
    url: config.baseUrl + url,
    data,
    method,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const RequestApiDisableHead = async (url, { data = '', method = 'POST' }) => {
  return axios({
    url,
    data,
    method,
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};
